
/**
 * Sprint Task
 * https://developerx.atlassian.net/browse/CS-5132
 *
 * Date Created : 13 Dec 2021       Created by   : Risman Abdilah
 * Date Updated : 13 Dec 2021       Updated by   : Risman Abdilah
 *
 * Version 1.0.1
 */

import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class ModalDeleteEvent extends Vue {
  /* VUEX */

  /* PROPS */
  @Prop({ default: false })
  private isShow: boolean;

  /* METHODS */
  private clickSubmit() {
    this.$emit("onConfirmed");
    this.$emit("update:isShow", false);
  }
}
